import { render, staticRenderFns } from "./soundboard-detail.vue?vue&type=template&id=3d93d7c5&"
import script from "./soundboard-detail.vue?vue&type=script&lang=js&"
export * from "./soundboard-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports